module.exports = __webpack_public_path__ + "media/src/assets/Images/info-circle-995cabf8abcd6a59e56fd49746ce92ba.svg";